import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { storableError } from '../../util/errors';
import { fetchLiveBidsListings as fetchLiveBidsListingsApi } from '../../util/api';
import { parse } from '../../util/urlHelpers';

import { types as sdkTypes } from '../../util/sdkLoader';
const { Money } = sdkTypes;

const SLICE_NAME = 'LiveBidSearchPage';

// ================ Async Thunks ================ //

export const fetchLiveBidsSearch = createAsyncThunk(
  `${SLICE_NAME}/fetchLiveBidsSearch`,
  async (params, { rejectWithValue }) => {
    try {
      const response = await fetchLiveBidsListingsApi({ ...params, includeAll: true });
      return response;
    } catch (e) {
      return rejectWithValue(storableError(e));
    }
  }
);

// ================ Slice ================ //

const initialState = {
  listings: [],
  pagination: null,
  inProgress: false,
  error: null,
};

const liveBidSearchSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchLiveBidsSearch.pending, state => {
        state.inProgress = true;
        state.error = null;
      })
      .addCase(fetchLiveBidsSearch.fulfilled, (state, action) => {
        state.inProgress = false;
        state.listings = (action.payload.data || []).map(l => {
          const price = l.attributes?.price;
          if (price && !(price instanceof Money)) {
            return {
              ...l,
              attributes: {
                ...l.attributes,
                price: new Money(price.amount, price.currency),
              },
            };
          }
          return l;
        });
        state.pagination = action.payload.meta || null;
      })
      .addCase(fetchLiveBidsSearch.rejected, (state, action) => {
        state.inProgress = false;
        state.error = action.payload;
      });
  },
});

export const liveBidSearchReducer = liveBidSearchSlice.reducer;

// ================ Selectors ================ //

export const liveBidsSearchListingsSelector = state => state.LiveBidSearchPage?.listings || [];
export const liveBidsSearchInProgressSelector = state => state.LiveBidSearchPage?.inProgress || false;
export const liveBidsSearchErrorSelector = state => state.LiveBidSearchPage?.error || null;
export const liveBidsSearchPaginationSelector = state => state.LiveBidSearchPage?.pagination || null;

// ================ Load data ================ //

export const loadData = (params, search, config) => dispatch => {
  const queryParams = parse(search);
  const { page = 1 } = queryParams;
  return dispatch(fetchLiveBidsSearch({ page: parseInt(page, 10), perPage: 16 }));
};

export default liveBidSearchReducer;
